import { useRef, useState } from 'react';

import cn from 'classnames';

import { ChecksSelector } from 'components/ChecksSelector/ChecksSelector';
import { Button } from 'components/FormComponents/';

import styles from './Step2Form.module.scss';

export const Step2Form = ({ stepBack = () => {}, ...props }) => {
  const selectorRef = useRef(null);

  const [valid, setValid] = useState(false);

  return (
    <div className={cn(styles.root)}>
      <div className={cn('card', 'card-with-border')}>
        <div className="u-margin--large">
          <div className={cn('u-flex-box', 'u-flex-justify-between', 'u-flex-align-center')}>
            <h1 className="title-3 u-margin-y">Step 2. Select Check Types</h1>
          </div>
        </div>
        <div className="border-t border-neutral-4">
          <ChecksSelector
            ref={selectorRef}
            {...props}
            setValidity={setValid}
            className="bg-neutral-2"
          />
        </div>
        <div className={cn('card_footer', 'u-flex-box', 'u-flex-justify-between')}>
          <Button onClick={stepBack} type="secondary">
            Back
          </Button>
          <Button
            onClick={() => selectorRef.current.submit()}
            disabled={!valid}
            dataTestId="launch-check-button">
            Launch Check
          </Button>
        </div>
      </div>
    </div>
  );
};
